import service from "@/plugins/axios";
import store from "@/store";
import { TopNavigationModel } from "@/models/topNavigation";

const request = new service();
const source = "/mkapi/";

export const GET_TOP_NAVIGATION = (
  topNavigationModel: TopNavigationModel,
  groupType: any,
) => {
  if (groupType == null) {
    return request.axiosCall({
      method: `get`,
      url: `${source}` + "navigation/GetTopnavigation",
      headers: {
        "original-url": topNavigationModel.originalUrl,
        Authorization: store.state.token,
      },
      params: {
        currentSiteId: topNavigationModel.currentSiteId,
      },
    });
  } else {
    return request.axiosCall({
      method: `get`,
      url: `${source}` + "navigation/GetTopnavigation",
      headers: {
        "original-url": topNavigationModel.originalUrl,
        Authorization: store.state.token,
      },
      params: {
        currentSiteId: topNavigationModel.currentSiteId,
        groupTag: groupType,
      },
    });
  }
};
